import { jsx as m } from "react/jsx-runtime";
import p from "react";
import a from "next/link";
import { Link as k } from "@sitecore-jss/sitecore-jss-nextjs";
const L = p.forwardRef(
  ({ href: n, field: r, className: i, children: f, prefetch: o, ...t }, e) => r ? /* @__PURE__ */ m(
    k,
    {
      prefetch: o ?? !1,
      ref: e,
      field: r,
      className: i,
      ...t,
      children: f
    }
  ) : /* @__PURE__ */ m(
    a,
    {
      prefetch: o ?? !1,
      ref: e,
      href: n || "",
      className: i,
      ...t,
      children: f
    }
  )
);
L.displayName = "UnifiedLink";
export {
  L as U
};
